"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorButton = exports.ErrorText = exports.ErrorTitle = exports.ErrorIcon = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const layout_1 = require("@nib/layout");
const button_1 = require("@nib-components/button");
const styles_1 = require("../../styles");
exports.Wrapper = styled_components_1.default.div`
  ${(0, layout_1.pl)(3)}
  ${(0, layout_1.pr)(3)}
  ${styles_1.mixins.square("100%")}
	display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  max-width: 360px;
  text-align: center;
`;
exports.ErrorIcon = styled_components_1.default.div`
  ${styles_1.mixins.square("45px")}
  ${(0, layout_1.mb)(5)}
`;
exports.ErrorTitle = styled_components_1.default.h2`
  font-weight: normal;
`;
exports.ErrorText = styled_components_1.default.p`
  font-size: ${styles_1.variables.ERROR_FONT_SIZE};
  ${(0, layout_1.mt)(0)}
`;
exports.ErrorButton = (0, styled_components_1.default)(button_1.PrimaryButton)`
  height: 60px;
  width: 100%;
  ${(0, layout_1.mt)(4)}

  svg {
    position: relative;
    top: 2px;
  }
`;